import { AuthUserModel } from "app/services/api/types/authorisation/models/AuthUserModel";
import { FC } from "react";
import { Text, View } from "react-native";
import { ProfileAvatar } from "app/components/atoms/ProfileAvatar";

interface Props {
  user: AuthUserModel;
}

export const UserListContent: FC<Props> = ({ user }) => {
  const roles = user.roles.map((role) => role.display_name).join(", ");
  const locations = user.locations.map((location) => location.name).join(", ");

  return (
    <View>
      <ProfileAvatar user={user} />
      <View className="flex flex-col py-3">
        <Text className="text-gray-600 mb-2">Role</Text>
        <Text>{roles}</Text>
      </View>
      <View className="flex flex-col py-3">
        <Text className="text-gray-600 mb-2">Location(s)</Text>
        <Text>{locations}</Text>
      </View>
    </View>
  );
};
